import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-top: 60px;

  ${up('sm')} {
    padding-top: 70px;
  }
`

const Content = styled.div`
  padding-top: 40px;
  padding-bottom: 28px;
  text-align: center;

  ${up('sm')} {
    text-align: left;
  }
`

const Suptitle = styled.h1`
  color: #0078c9;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  text-transform: uppercase;
`

const Title = styled.h2`
  margin: 0;
  font-size: 17px;
  font-weight: bold;
`

interface Props {
  suptitle: string
  title: string
}

export const Header: ComponentType<Props> = ({ suptitle, title }) => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          <Content>
            <Suptitle>{suptitle}</Suptitle>
            <Title>{title}</Title>
          </Content>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
